let currentBreakpoint = () => {
    return window.getComputedStyle($('#sizer')[0], ':before')['content'].replaceAll('"', '');
}

exports.currentBreakpoint = currentBreakpoint;


// WEBPACK FOOTER //
// ./scripts/util/currentBreakpoint.js